import React, { useEffect } from "react";
const EventCard = ({
  setCurrentEvent,
  setSelectedEvent,
  titre,
  date,
  description,
  cover,
  galery,
}) => {
  const handleSelect = () => {
    setCurrentEvent({
      titre: titre,
      date: date,
      bio: description,
      cover: cover,
      galery: galery,
    });
    setSelectedEvent(true);
  };

  useEffect(() => {}, [cover]);

  return (
    <>
      {cover && (
        <div
          onClick={handleSelect}
          style={{
            backgroundImage: `url(https://cdn.sanity.io/images/xazjl9sh/production/${cover.slice(6, -4)}.${cover.slice(-3)})`,
          }}
          className='cursor-pointer h-[513px] w-[360px]'
        >
          <div className='hover:bg-[rgba(250,223,0,0.5)] h-full w-full grid items-end'>
            <div className='p-8'>
              <h1 className='text-2xl text-white font-semibold'>{titre}</h1>
              {date && (
                <p className='text-thin text-white text-lg'>{date.slice(0, 10)}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EventCard;

